import React, {Component} from "react";
import {BannerHeader} from "../structure";
import {Footer} from './../common/common';

import bgImg from "../../resources/images/bg-register.jpg"

class Shipping extends Component {

	componentDidMount() {
		document.getElementById("content").scrollTo(0, 0);
	}

	render(){
		return(
			<article className="festenInfoPage">
				<BannerHeader bgImage={bgImg}>
					<h1>Levering</h1>
				</BannerHeader>
				<div className="maxWidth">
					<section className="infoSection">
						<h1>Leveringtid</h1>
						<p>
							Levering af varer fra Festen.dk anses for sket, n&aring;r kunden har f&aring;et varen udleveret.
						</p>
						<p>
							Alle bestillinger sendes med Post Danmark/GLS, hvis ikke andet er aftalt s&aelig;rskilt mellem k&oslash;ber og
							Festen.dk.
						</p>
						<p>
							Ved enkelte samarbejdspartnere er der mulighed for enten at hente varen selv, eller at
							samarbejdspartnere levere varen, dette v&aelig;lges under levering.
						</p>
						<p>
							Dette betyder, at varene sendes indenfor maksimalt 5 dage efter modtaget ordre.
							Levering p&aring; k&oslash;bers adresse i Danmark vil derfor normalt
							ske indenfor 3 dage. 
						</p>
						<p>
							Oplyste leveringstidspunkt er vejledende og kan s&aring;ledes fravige.
						</p>
					</section>

					<section className="infoSection">
						<h1>Hvorfor kommer der flere pakker?</h1>
						<p>Festen.dk er en markedsplads, s&aring; det er muligt at du foretager en bestilling fra forskellige butikker.</p>
						<p>Det betyder at de vare kan komme i flere pakker.</p>
						<h2>
							&Aring;bningstider<br/>
							Mandag-torsdag: 09:00 - 16:00<br/>
							Fredag: 09:00 - 15:00
						</h2>
					</section>

					<section className="infoSection">
						<h1>Dine personlige oplysninger</h1>
						<p>
							Hos Festen handels der direkte med fysiske butikker p&aring; vores platform www.festen.dk . For at butikkerne
							kan behandle og fremsende din ordre, deles dine oplysninger med de butikker som skal levere din ordre.
						</p>
						<p>
							Ligeledes deles dine oplysninger med eksterne distribut&oslash;rer, GLS og Post Nord.
						</p>
						<p>
							Vi registrerer ingen personf&oslash;lsomme oplysninger.
						</p>
						<p>
							Som registreret hos Festen har du altid ret til at g&oslash;re indsigelse mod registreringen. Du har
							ogs&aring; ret til indsigt i, hvilke oplysninger der er registreret om dig. Disse rettigheder har du efter
							persondataloven. Henvendelse i forbindelse hermed rettes til Festen via e-mail: <a href="mailto:kontakt@festen.dk">kontakt@festen.dk</a>
						</p>
					</section>

				</div>
				<Footer/>
			</article>
		)
	}
};

export default Shipping;



// WEBPACK FOOTER //
// ./src/components/infoPages/shipping.js